module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"challengesAndOpportunities":"Challenges & Opportunities","drivers":"Treiber","mainstreamAdoption":"Reifegrad","threads":"Beiträge"},"en":{"challengesAndOpportunities":"Challenges & Opportunities","drivers":"Drivers","mainstreamAdoption":"Mainstream Adoption","threads":"Posts"}}')
  delete Component.options._Ctor
}
